/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_TodayInputs */

const vi_einvoice_draft_today = /** @type {(inputs: Einvoice_Draft_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hôm nay`)
};

/**

* @param {Einvoice_Draft_TodayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_today = /** @type {((inputs?: Einvoice_Draft_TodayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_TodayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_today(inputs)
});